import React, { useState } from "react";
import { makeStyles, IconButton } from "@material-ui/core";
import { ArrowBackIos, ArrowForwardIos } from "@material-ui/icons";

// Import images
import img1 from "../../../assets/Images/Howwework/1.png";
import img2 from "../../../assets/Images/Howwework/2.png";
import img3 from "../../../assets/Images/Howwework/3.png";
import img4 from "../../../assets/Images/Howwework/4.png";
import img5 from "../../../assets/Images/Howwework/5.png";


const images = [img1, img2, img3, img4, img5];

const useStyles = makeStyles({
  root: {
    borderRadius: "24px",
    boxShadow: "0 0 40px rgba(105, 180, 75, 0.05)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  sliderWrapper: {
    position: "relative",
    width: "70%",
    overflow: "hidden",
    borderRadius: "10px",
  },
  slidesContainer: {
    display: "flex",
    transition: "transform 0.5s ease-in-out",
  },
  slide: {
    minWidth: "100%",
    height: "auto",
    objectFit: "cover",
    borderRadius: "10px",
  },
  arrowButton: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  leftArrow: {
    left: "5px",
    transform: "scale(1.5)", // scale it up by 1.5x
  transformOrigin: "center",
  color:"black"
    

  },
  rightArrow: {
    right: "5px",
    transform: "scale(1.5)", // scale it up by 1.5x
    transformOrigin: "center",
    color:"black"

  },
});

const Work = () => {
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.sliderWrapper}>
        <div
          className={classes.slidesContainer}
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Slide ${index + 1}`}
              className={classes.slide}
            />
          ))}
        </div>
        <IconButton
          className={`${classes.arrowButton} ${classes.leftArrow}`}
          onClick={goToPrev}
        >
          <ArrowBackIos />
        </IconButton>
        <IconButton
          className={`${classes.arrowButton} ${classes.rightArrow}`}
          onClick={goToNext}
        >
          <ArrowForwardIos />
        </IconButton>
      </div>
    </div>
  );
};

export default Work;